<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn id="btn-adicionar" text small color="primary" @click="adicionar"> <v-icon left>mdi-bank</v-icon>Adicionar </v-btn>

        <v-btn text id="btn-atualizar" @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn-atualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search v-model="busca" select class="ml-5" @keydown.enter="buscar" @click:clear="limparBusca"></z-text-field-search>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-card>
          <v-data-table mobile-breakpoint="0" :options.sync="paginacao" :server-items-length="total_itens" :footer-props="$v.FOOTER_PROPS" :headers="headers" :items="bancos" item-key="id">
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.codigo }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)" class="ma-0">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluir(item)" class="ma-0">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <z-dialogo-sim-nao ref="dialogoRemover" titulo="Remover banco?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      O banco será removido do sistema.
    </z-dialogo-sim-nao>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="700px" titulo="Banco" dividers persistent @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="3">
              <z-text-field v-model="banco.codigo" maxlength="3" ref="descricao" label="Código" placeholder=" " :rules="[regras.campoObrigatorio]"></z-text-field>
            </v-col>
            <v-col cols="12" sm="9">
              <z-text-field v-model="banco.descricao" ref="descricao" label="Descrição" placeholder=" " :rules="[regras.campoObrigatorio]"></z-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn color="primary" ref="btnConfirmar" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import * as regras from '@/app/helpers/validacoes';

export default {
  name: 'BancosLista',
  data() {
    return {
      headers: [
        { text: 'Código', value: 'codigo', width: '150px' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Opções', value: '', width: '200px', align: 'center', sortable: false },
      ],
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: { ...regras },
    };
  },

  computed: {
    ...mapState(['loading']),
    ...mapState('bancos', ['bancos', 'banco', 'total_itens']),

    busca: {
      get() {
        return this.$store.state.bancos.busca;
      },
      set(busca) {
        this.$store.commit('bancos/SET_BUSCA', busca);
      },
    },

    paginacao: {
      get() {
        return this.$store.state.bancos.paginacao;
      },
      set(paginacao) {
        this.$store.commit('bancos/UPDATE_PAGINACAO', paginacao);
      },
    },
  },

  created() {
    this.refresh();
  },

  inject: ['notifications'],

  async mounted() {
    this.setTitulo('Bancos');
  },

  methods: {
    ...mapMutations(['setTitulo', 'LOADING_OFF']),
    ...mapActions('bancos', ['listar', 'excluir', 'abrir', 'atualizar', 'salvar']),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível listar os bancos.');
      }
    },

    buscar() {
      this.$store.commit('bancos/SET_PAGE', 1);
      this.refresh();
    },

    limparBusca() {
      this.busca = null;
      this.$store.commit('bancos/SET_PAGE', 1);
      this.refresh();
    },

    adicionar() {
      this.$store.commit('bancos/ZERAR');
      this.$refs.dialogoAdicionar.abrir();
    },

    async editar(banco) {
      try {
        await this.abrir(banco.id);
        this.$refs.dialogoAdicionar.abrir();
      } catch (error) {
        console.log(error);
        this.notifications.notificarErro('Não foi possível abrir o banco.');
      } finally {
        this.LOADING_OFF();
      }
    },

    async confirmar() {

      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.banco.id) {
          await this.atualizar(this.banco);
        } else {
          await this.salvar(this.banco);
        }

        this.$refs.dialogoAdicionar.fechar();
        this.notifications.notificar('Tipo de banco salvo com sucesso');
      } catch (error) {
        this.notifications.notificarErro('Não foi possível salvar esta banco. Verifique os dados preenchidos.', error);
        throw error;
      } finally {
        this.salvando = false;
      }
    },

    async perguntarExcluir(banco) {
      let resposta = await this.notifications.dialogo_pergunta.abrir({
        titulo: 'Remover Banco?',
        texto: 'O banco será removido do sistema.',
        botoes: ['Cancelar', 'Remover'],
        padrao: 'Remover',
        cor: 'red',
      });

      if (resposta == 'Remover') {
        this.notifications.dialogo_pergunta.carregando();
        await this.confirmarExcluir(banco);
        this.notifications.dialogo_pergunta.fechar();
      } else {
        this.notifications.dialogo_pergunta.fechar();
      }
    },

    async confirmarExcluir(banco) {
      try {
        this.excluindo = true;
        await this.excluir(banco.id);
        this.notifications.notificar('Banco excluído com sucesso!');
      } catch (error) {
        this.notifications.notificarErro('Não foi possível excluir o banco!');
        this.notifications.dialogo_pergunta.fechar();
        throw error;
      } finally {
        this.excluindo = false;
      }
    },
  },

  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<script setup>

// import { inject, onMounted } from 'vue';
// const notifications = inject('notifications');



</script>

<style scoped></style>
